import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import styled from 'styled-components';
import * as toastr from "toastr";

import * as close from "Placements/Assets/svg/closeRed.svg";
import * as checked from "Placements/Assets/svg/checkedGreen.svg";

import GetStaticAudioUrl from "Placements/Utils/GetStaticAudioUrl.util";
import GetStaticImgUrl from "Placements/Utils/GetStaticImgUrl.util";
import getConfig from "Placements/Utils/GetRequestConfig.util";
import API from "Placements/API";
import Breadcrumb from 'Placements/Components/Breadcrumb'
import Loader from "Placements/Components/Loader";
import AudioPlayer from "Placements/Components/AudioPlayerPlacement";
import { ContainerFlex } from "Placements/Styles/Global.style";

const ContainerFlexStyled = styled(ContainerFlex)`
    .page_map{
        font-weight: 600;
        color: #66279b !important;
        a{
            text-decoration: none;
            color: #66279b !important;
        }

        a: hover{
            text-decoration: underline;
        }
    }
`;

const Main = styled.div`
    width: 100%;
    max-width: 768px;
    margin: 30px auto;

    .neutral{
        background-color: #505050;
    }

    .wrong{
        background-color: #ff7575;;
    }

    .right{
        background-color: #18c258;;
    }

    @media screen and (max-width: 768px){

        width: 100%;
        margin: 20px auto;
    }
`;

const QuestionWrapper = styled.div`
    background-color: #fff;
    padding: 24px;
    margin-top: 3rem;
    position: relative;

    h2{
        font-size: 16px;
        font-weight: 600;
        color: #66279b;
        // font-family: pantonbold;
    }

    .audio{
        padding: 20px 10px;
    }
`;

const QuestionNumber = styled.div`
    position: absolute;
    top: -16px;
    left: -24px;
    background: #66279b;
    font-size: 14px;
    // font-family: pantonbold;
    font-weight: 600;
    color: #fff;
    padding: 8px 16px;
`;

const SubQuestion = styled.div`
    color: #505050;
    font-size: 16px;
    // font-family: pantonbold;
    font-weight: 600;

    img{
        width: 100%;
    }

`;

const Answer = styled.img`
    float: left;
    color: red;
    // font-size: 32px;
    position: absolute;
    top: 24px;
    right: 24px;
`;

const Alternatives = styled.div`
    display: -webkit-box;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    justify-content: space-between;
    flex-wrap: wrap;

    @media (max-width: 480px){
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
    }
`;

const AnswerOption = styled.div`
    background: #505050;
    -webkit-box-flex: 0;
    flex: 0 0 calc(50% - 16px);
    padding: 24px 0;
    text-align: center;
    color: #fff;
    margin-top: 16px;

    @media (max-width: 480px){
        width: 100%;
    }
`;

const ExerciseAnswered = (props: any) => {

    const { match: { params } } = props;
    const [listExercises, setListExercises] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [userTest, setUserTest] = useState("");

    useEffect(() => {

        if (params.testeParte) {
            fetchExercises(params.testeParte, params.idExercice);
            setUserTest(localStorage.getItem("idTesteUser"));
        } else {

            toastr.error('Parâmetro do teste não encontrados.');
            window.location.href = "#/admin/test-list";

        }

    }, []);

    const fetchExercises = async (testeParte: any, idExercice: any) => {

        try {
            const response = await API.Admin.GetExercisesAnswer({ id: testeParte, idExercicio: idExercice }, getConfig());
            // const response = await API.Admin.GetExercisesAnswer({id: "14754", idExercicio: ""}, getConfig());

            setListExercises(response.data);

        } catch (error) {

            toastr.error('Não foi possível obter os exercícios.');
            console.error(error);
            window.location.href = "#/admin/test-list";

        } finally {

            setLoading(false);

        }

    }

    const getTypeSubQuestion = (exercise: any) => {

        let htmlTemplate: any = null;

        if (exercise.Subenunciado !== null) {
            htmlTemplate = exercise.Subenunciado;

        } else if (exercise.TextoTela !== null) {
            htmlTemplate = exercise.TextoTela;

        } else if (exercise.Imagem !== null) {
            // htmlTemplate = `<img src="http://www.placement.yazigi.com.br/${exercise.Imagem.replace("../..", "")}"/>`;
            htmlTemplate = `<img src="${GetStaticImgUrl(exercise.Imagem)}"/>`;

        }

        return { __html: htmlTemplate };

    }

    const markAlternative = (exercise: any): any[] => {

        let htmlForms: any[] = [];

        try {

            exercise.Alternativa.map((alternative: any, index: number) => {

                if (exercise.Id_Alternativa_Resposta === alternative.Id_Alternativa) {

                    if (exercise.Resultado) {
                        htmlForms.push(<AnswerOption className="right" key={index}> {alternative.Descricao} </AnswerOption>);
                    } else {
                        htmlForms.push(<AnswerOption className="wrong" key={index}> {alternative.Descricao} </AnswerOption>);
                    }

                } else {

                    if (alternative.Fl_Correta) {
                        htmlForms.push(<AnswerOption className="right" key={index}> {alternative.Descricao} </AnswerOption>);
                    } else {
                        htmlForms.push(<AnswerOption className="neutral" key={index}> {alternative.Descricao} </AnswerOption>);
                    }

                }

            });

        } catch (error) {

            toastr.error('Ocorreu um erro ao carregar as alternativas.');
            console.error(error);

        }

        return htmlForms;

    }

    const getBreadcrumb = () => {
        return [
            { path: "/admin/test-list", label: "Listagem de Testes" },
            { path: "/admin/test-list/" + userTest, label: "Detalhes do teste" },
            { path: "", label: " Exercício respondido" },
        ]
    }

    return (
        <ContainerFlexStyled>
            <Col md={10}>
                {isLoading && <Loader />}
                <Breadcrumb links={getBreadcrumb()} />
                <Main>
                    {listExercises.map((exercise: any, index: number) => (
                        <QuestionWrapper key={index}>
                            {exercise.Resultado ? <Answer src={checked} /> : <Answer src={close} />}
                            <QuestionNumber>Question {exercise.Ordem}</QuestionNumber>
                            <br />
                            <h2 dangerouslySetInnerHTML={{ __html: exercise.Enunciado === "" ? exercise.EnunciadoTela : exercise.Enunciado }} />
                            <br />
                            {
                                exercise.Audio !== null ?
                                    <SubQuestion className="audio">
                                        {/* <AudioPlayer src={"http://www.placement.yazigi.com.br"+ exercise.Audio.replace("../..", "").replace(" ", "%20")}/>  */}
                                        <AudioPlayer src={GetStaticAudioUrl(exercise.Audio)} />
                                    </SubQuestion> :
                                    <SubQuestion dangerouslySetInnerHTML={getTypeSubQuestion(exercise)} />
                            }
                            <Alternatives>
                                {markAlternative(exercise)}
                            </Alternatives>
                        </QuestionWrapper>
                    ))}
                </Main>
            </Col>
        </ContainerFlexStyled>
    );

}

export default ExerciseAnswered;

